import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
    overrideComponent,
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
    StepComponent,
} from '@sheerid/jslib';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './components/step/StepStudentPersonalInfoComponent';
import { addBirthDateValidator } from './lib/utils/validators';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();

addBirthDateValidator();
setMetadata({ parentalConsent: false });

overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent as unknown as StepComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
